export default __webpack_public_path__ + "static/media/starsbg.d22a5f88.svg";